import React from 'react';
import "./Header.css";
import HomeIcon from "@material-ui/icons/Home";
import FlashOnIcon from "@material-ui/icons/FlashOn";
import LiveTvIcon from "@material-ui/icons/LiveTv";
import VideoLibraryIcon from "@material-ui/icons/VideoLibrary";
import SearchIcon from "@material-ui/icons/Search";
import PersonOutlineIcon from "@material-ui/icons/PersonOutline";
import GradeIcon from '@material-ui/icons/Grade';
import requests from "./requests";

function Header({ setSelectedOption }) {

    // const [cssclass, setcssClass] = useState("");

    return (
        <div className="header">
            <div className="header__icons">

                <div className="header__icon header__icon--active">
                    <HomeIcon />
                    <p>Home</p>
                </div>

                <div className="header__icon" onClick={() => setSelectedOption(requests.fetchMovie)}>
                    <LiveTvIcon />
                    <p>Movies</p>
                </div>

                <div className="header__icon" onClick={() => setSelectedOption(requests.fetchTV)}>
                    <VideoLibraryIcon />
                    <p >TV SERIES</p>
                </div>

                <div className="header__icon" onClick={() => setSelectedOption(requests.fetchTrending)}>
                    <FlashOnIcon />
                    <p>Trending</p>
                </div>


                <div className="header__icon" onClick={() => setSelectedOption(requests.fetchTopRated)}>
                    <GradeIcon />
                    <p>Top Rated</p>
                </div>



                <div className="header__icon">
                    <SearchIcon />
                    <p>Search</p>
                </div>

                <div className="header__icon">
                    <PersonOutlineIcon />
                    <p>Account</p>
                </div>

            </div>
            {/* <img src="https://fontmeme.com/temporary/e6d5b6a7cb8fa81be89a118d9dab3d3b.png" alt="" /> */}
            {/* <img src="https://fontmeme.com/temporary/3e58f5f4053df0b57b9dbffec10c5dcb.png" alt="" /> */}
            <img src="https://fontmeme.com/permalink/200930/b4e1009bfed9491403f318a5976dfecd.png" alt="" />
            {/* <img src="https://fontmeme.com/permalink/200930/5fa6af0dca45a0fbcd6a9d05d58a545b.png" alt="" /> */}
        </div>
    )
}

export default Header
